import React, { useState, useEffect, useRef } from "react";
import "../../styles/SuccessStories.css";
import { getStories, getStoryCategories } from "../../api/contentApi";
import CustomYouTubePlayer from "../learning/CustomYouTubePlayer";

export default function SuccessStories() {
  
  const [activeFilter, setActiveFilter] = useState("all");
  const [sortBy, setSortBy] = useState("mostRecent");
  const [isSortOpen, setIsSortOpen] = useState(false);
  

  const [isViewAllOpen, setIsViewAllOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [visibleCount, setVisibleCount] = useState(6);
  const [apiStories, setApiStories] = useState(null);
  const [apiCategories, setApiCategories] = useState([]);


  const [selectedVideoUrl, setSelectedVideoUrl] = useState(null);
  const [isSubmitModalOpen, setIsSubmitModalOpen] = useState(false);


  const [submitForm, setSubmitForm] = useState({
    name: "",
    handle: "",
    platform: "YouTube",
    earnings: "",
    story: ""
  });

  const carouselRef = useRef(null);

  const sortOptions = [
    { label: "Most Recent", value: "mostRecent" },
    { label: "Top Earnings", value: "topRated" },
    { label: "Most Popular", value: "popular" }
  ];

  const selectedOptionLabel = sortOptions.find(opt => opt.value === sortBy)?.label || "Most Recent";

 
  const fallbackStories = [
    {
      id: 1,
      name: "Rohit Sharma",
      handle: "@rohitcreates",
      platform: "YouTube",
      badgeColor: "#ff0000",
      image: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=600&q=80",
      videoUrl: "https://www.youtube.com/embed/-34KeSMV0SI?autoplay=1",
      description: "From college student to 1M+ subscribers in 2 years",
      metric1: "1.2M Subscribers",
      metric2: "₹25L+ /month",
      category: "youtube",
      earningsNum: 2500000,
      popularity: 98,
      date: "2026-07-15"
    },
    {
      id: 2,
      name: "Priya Verma",
      handle: "@priyacreates",
      platform: "Instagram",
      badgeColor: "#e1306c",
      image: "https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format&fit=crop&w=600&q=80",
      videoUrl: "https://www.youtube.com/embed/-34KeSMV0SI?autoplay=1",
      description: "Built a personal brand and earned through collaborations",
      metric1: "250K Followers",
      metric2: "₹6L+ /month",
      category: "instagram",
      earningsNum: 600000,
      popularity: 88,
      date: "2026-08-01"
    },
    {
      id: 3,
      name: "Arjun Mehta",
      handle: "@arjun.designs",
      platform: "Freelancer",
      badgeColor: "#0077b5",
      image: "https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?auto=format&fit=crop&w=600&q=80",
      videoUrl: "https://www.youtube.com/embed/-34KeSMV0SI?autoplay=1",
      description: "From beginner to top rated freelance UI/UX designer",
      metric1: "Top Rated",
      metric2: "₹3L+ /month",
      category: "freelancing",
      earningsNum: 300000,
      popularity: 82,
      date: "2026-06-20"
    },
    {
      id: 4,
      name: "Neha Joshi",
      handle: "@nehatalks",
      platform: "Podcast",
      badgeColor: "#8e44ad",
      image: "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?auto=format&fit=crop&w=600&q=80",
      videoUrl: "https://www.youtube.com/embed/-34KeSMV0SI?autoplay=1",
      description: "Built a top 1% podcast and monetized with sponsors",
      metric1: "100K+ Listeners",
      metric2: "₹2L+ /month",
      category: "podcasts",
      earningsNum: 200000,
      popularity: 90,
      date: "2026-08-05"
    },
    {
      id: 5,
      name: "Kabir Roy",
      handle: "@kabirtech",
      platform: "YouTube",
      badgeColor: "#ff0000",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=600&q=80",
      videoUrl: "https://www.youtube.com/embed/-34KeSMV0SI?autoplay=1",
      description: "Scaled a tech gadget review channel to 500K subs",
      metric1: "500K Subscribers",
      metric2: "₹12L+ /month",
      category: "youtube",
      earningsNum: 1200000,
      popularity: 92,
      date: "2026-05-10"
    },
    {
      id: 6,
      name: "Ananya Deshmukh",
      handle: "@ananyafits",
      platform: "Instagram",
      badgeColor: "#e1306c",
      image: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=600&q=80",
      videoUrl: "https://www.youtube.com/embed/-34KeSMV0SI?autoplay=1",
      description: "Monetized fitness routines via brand sponsorship deals",
      metric1: "420K Followers",
      metric2: "₹8L+ /month",
      category: "instagram",
      earningsNum: 800000,
      popularity: 85,
      date: "2026-04-12"
    },
    {
      id: 7,
      name: "Vikramaditya Bose",
      handle: "@vikramcodes",
      platform: "Freelancer",
      badgeColor: "#0077b5",
      image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=600&q=80",
      videoUrl: "https://www.youtube.com/embed/-34KeSMV0SI?autoplay=1",
      description: "Full-stack developer landing high-ticket US clients",
      metric1: "Top Rated Plus",
      metric2: "₹15L+ /month",
      category: "freelancing",
      earningsNum: 1500000,
      popularity: 94,
      date: "2026-03-22"
    },
    {
      id: 8,
      name: "Sanya Malhotra",
      handle: "@sanyavlogs",
      platform: "YouTube",
      badgeColor: "#ff0000",
      image: "https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format&fit=crop&w=600&q=80",
      videoUrl: "https://www.youtube.com/embed/-34KeSMV0SI?autoplay=1",
      description: "Travel & lifestyle vlogger growing a massive community",
      metric1: "800K Subscribers",
      metric2: "₹18L+ /month",
      category: "youtube",
      earningsNum: 1800000,
      popularity: 96,
      date: "2026-02-18"
    },
    {
      id: 9,
      name: "Tanmay Bhasin",
      handle: "@tanmaytalks",
      platform: "Podcast",
      badgeColor: "#8e44ad",
      image: "https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?auto=format&fit=crop&w=600&q=80",
      videoUrl: "https://www.youtube.com/embed/-34KeSMV0SI?autoplay=1",
      description: "Business & startup podcast crossing 2M downloads",
      metric1: "2M+ Downloads",
      metric2: "₹5L+ /month",
      category: "podcasts",
      earningsNum: 500000,
      popularity: 87,
      date: "2026-01-30"
    },
    {
      id: 10,
      name: "Rohan Kapoor",
      handle: "@rohankapoor",
      platform: "Others",
      badgeColor: "#475569",
      image: "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?auto=format&fit=crop&w=600&q=80",
      videoUrl: "https://www.youtube.com/embed/-34KeSMV0SI?autoplay=1",
      description: "Newsletter & Substack writer generating recurring ARR",
      metric1: "35K Readers",
      metric2: "₹4L+ /month",
      category: "others",
      earningsNum: 400000,
      popularity: 80,
      date: "2026-07-02"
    }
  ];


  useEffect(() => {
    if (selectedVideoUrl || isSubmitModalOpen) {
      document.body.classList.add("cd-body-scroll-lock");
    } else {
      document.body.classList.remove("cd-body-scroll-lock");
    }
    return () => document.body.classList.remove("cd-body-scroll-lock");
  }, [selectedVideoUrl, isSubmitModalOpen]);


  useEffect(() => {
    getStories({
      search: searchQuery,
      platform: activeFilter,
      sort: sortBy,
    })
      .then((items) => setApiStories(Array.isArray(items) ? items.map((item) => ({
        id: item.id,
        name: item.creator || item.title,
        handle: item.handle || '',
        platform: item.platform || 'Creator',
        badgeColor: item.platform === 'Instagram' ? '#e1306c' : '#ff0000',
        image: item.imageUrl,
        videoUrl: item.videoUrl,
        description: item.title,
        metric1: item.listeners || item.niche || 'Creator growth',
        metric2: item.earnings ? `₹${item.earnings}` : 'Growing revenue',
        category: String(item.platform || 'creator').toLowerCase(),
        earningsNum: Number(item.earnings || 0),
        popularity: 0,
        date: item.createdAt,
      })) : []))
      .catch((error) => console.error("Unable to load success stories:", error));
  }, [activeFilter, searchQuery, sortBy]);

  useEffect(() => {
    getStoryCategories()
      .then((items) => setApiCategories(Array.isArray(items) ? items : []))
      .catch((error) => console.error("Unable to load story categories:", error));
  }, []);

  const stories = apiStories || fallbackStories;

  const filteredStories = apiStories
    ? stories
    : stories
        .filter((item) => (activeFilter === "all" ? true : item.category === activeFilter))
        .filter((item) =>
          item.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
          item.handle.toLowerCase().includes(searchQuery.toLowerCase()) ||
          item.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
          item.platform.toLowerCase().includes(searchQuery.toLowerCase())
        )
        .sort((a, b) => {
          if (sortBy === "topRated") return b.earningsNum - a.earningsNum;
          if (sortBy === "popular") return b.popularity - a.popularity;
          return new Date(b.date) - new Date(a.date);
        });

 
  const displayedStories = isViewAllOpen 
    ? filteredStories.slice(0, visibleCount) 
    : filteredStories.slice(0, 6);


  const handleScrollCarousel = (direction) => {
    if (carouselRef.current) {
      const card = carouselRef.current.querySelector('.ss-story-card');
      const cardWidth = card ? card.offsetWidth : 280;
      const scrollAmount = direction === "left" ? -(cardWidth + 24) : (cardWidth + 24);
      
      carouselRef.current.scrollBy({
        left: scrollAmount,
        behavior: "smooth"
      });
    }
  };


  const handleFormSubmit = (e) => {
    e.preventDefault();
    alert(`Thank you, ${submitForm.name}! Your success story has been submitted for review.`);
    setSubmitForm({ name: "", handle: "", platform: "YouTube", earnings: "", story: "" });
    setIsSubmitModalOpen(false);
  };

  const handleToggleViewAll = () => {
    setIsViewAllOpen(!isViewAllOpen);
    setVisibleCount(6);
  };

  return (
    <div className="ss-page-wrapper">
      
      <section className="ss-hero-section ss-max-width">
        <div className="ss-hero-left">
  
 
  <div className="ss-unified-trust-pill">
    <span className="ss-pill-category">SUCCESS STORIES</span>
    <span className="ss-pill-divider">|</span>
    <div className="ss-avatar-stack-inline">
      <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=100&q=80" alt="C1" />
      <img src="https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format&fit=crop&w=100&q=80" alt="C2" />
      <img src="https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?auto=format&fit=crop&w=100&q=80" alt="C3" />
    </div>
    <span className="ss-stars-inline">★★★★★</span>
    <span className="ss-pill-count">10,000+ Creators</span>
  </div>

  
  <h1 className="ss-hero-title">
    Real Creators. <br />
    Real <span className="ss-text-blue-gradient">Results.</span>
  </h1>

  
  <p className="ss-hero-subtitle">
    From beginners to full-time creators — see how Creators Dost has helped thousands turn their passion into a successful, high-earning career.
  </p>

  
  <div className="ss-hero-cta-group">
    <button className="ss-btn-primary" onClick={() => setIsSubmitModalOpen(true)}>
      Share Your Story <span className="ss-btn-arrow">➔</span>
    </button>
    <button className="ss-btn-outline" onClick={() => window.location.hash = '#courses'}>
      Browse Courses
    </button>
  </div>

</div>

        
        <div className="ss-hero-right">
          <div className="ss-photo-cluster-wrapper">
            <div className="ss-dot-grid-accent" />
            <div className="ss-glow-ring-accent" />
            <div className="ss-sparkle-star">✦</div>

            <div className="ss-photo-grid-2x2">
              <div className="ss-grid-photo-card" onClick={() => setSelectedVideoUrl("https://www.youtube.com/embed/-34KeSMV0SI?autoplay=1")}>
                <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=500&q=80" alt="Rohit Sharma" />
              </div>
              <div className="ss-grid-photo-card" onClick={() => setSelectedVideoUrl("https://www.youtube.com/embed/-34KeSMV0SI?autoplay=1")}>
                <img src="https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format&fit=crop&w=500&q=80" alt="Priya Verma" />
              </div>
              <div className="ss-grid-photo-card" onClick={() => setSelectedVideoUrl("https://www.youtube.com/embed/-34KeSMV0SI?autoplay=1")}>
                <img src="https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?auto=format&fit=crop&w=500&q=80" alt="Arjun Mehta" />
              </div>
              <div className="ss-grid-photo-card" onClick={() => setSelectedVideoUrl("https://www.youtube.com/embed/-34KeSMV0SI?autoplay=1")}>
                <img src="https://images.unsplash.com/photo-1524504388940-b1c1722653e1?auto=format&fit=crop&w=500&q=80" alt="Neha Joshi" />
              </div>
            </div>

            <button 
              className="ss-center-play-btn" 
              aria-label="Play Success Video"
              onClick={() => setSelectedVideoUrl("https://www.youtube.com/embed/-34KeSMV0SI?autoplay=1")}
            >
              <span className="ss-play-triangle">▶</span>
            </button>
          </div>
        </div>
      </section>

      
      <section className="ss-max-width">
        <div className="ss-impact-banner">
          <div className="ss-impact-header">
            <h3>Our Impact</h3>
            <h2>In Numbers</h2>
          </div>
          
          <div className="ss-impact-stats-row">
            <div className="ss-impact-stat-item">
              <div className="ss-stat-icon">👍</div>
              <h4>50,000+</h4>
              <p>Success Stories</p>
            </div>
            <div className="ss-impact-stat-item">
              <div className="ss-stat-icon">🌐</div>
              <h4>100+</h4>
              <p>Countries</p>
            </div>
            <div className="ss-impact-stat-item">
              <div className="ss-stat-icon">💼</div>
              <h4>1000+</h4>
              <p>Careers Transformed</p>
            </div>
            <div className="ss-impact-stat-item">
              <div className="ss-stat-icon">₹</div>
              <h4>₹50Cr+</h4>
              <p>Earned by Creators</p>
            </div>
            <div className="ss-impact-stat-item">
              <div className="ss-stat-icon">⭐</div>
              <h4>4.9/5</h4>
              <p>Average Rating</p>
            </div>
          </div>
        </div>
      </section>

      
      <section className="ss-max-width ss-filter-section">
        <div className="ss-filter-pills">
          <button className={`ss-filter-pill ${activeFilter === "all" ? "active" : ""}`} onClick={() => setActiveFilter("all")}>📊 /Stories</button>
          {(apiCategories.length ? apiCategories : ["YouTube", "Instagram", "Freelancer", "Podcast", "Others"]).map((category) => {
            const value = category.toLowerCase();
            return (
              <button key={category} className={`ss-filter-pill ${activeFilter === value ? "active" : ""}`} onClick={() => setActiveFilter(value)}>
                • {category}
              </button>
            );
          })}
        </div>

        <div className="ss-custom-dropdown-container">
          <button 
            className={`ss-dropdown-trigger-btn ${isSortOpen ? "active" : ""}`}
            onClick={() => setIsSortOpen(!isSortOpen)}
            type="button"
          >
            <span>{selectedOptionLabel}</span>
            <span className={`ss-dropdown-chevron ${isSortOpen ? "rotate" : ""}`}>▾</span>
          </button>

          {isSortOpen && (
            <>
              <div className="ss-dropdown-backdrop-close" onClick={() => setIsSortOpen(false)} />
              <ul className="ss-dropdown-menu-list">
                {sortOptions.map((option) => (
                  <li
                    key={option.value}
                    className={`ss-dropdown-item ${sortBy === option.value ? "selected" : ""}`}
                    onClick={() => {
                      setSortBy(option.value);
                      setIsSortOpen(false);
                    }}
                  >
                    {option.label}
                    {sortBy === option.value && <span className="ss-check-mark">✓</span>}
                  </li>
                ))}
              </ul>
            </>
          )}
        </div>
      </section>

      
      <section className="ss-max-width ss-featured-section">
        <div className="ss-section-header">
          <h2>
            {isViewAllOpen ? "All " : "Featured "}
            <span className="ss-text-blue">Success Stories</span>
          </h2>
          <span className="ss-view-all-link" onClick={handleToggleViewAll}>
            {isViewAllOpen ? "Show Less ▴" : "View All Stories ➔"}
          </span>
        </div>

        
        {isViewAllOpen && (
          <div className="ss-search-bar-row">
            <input
              type="text"
              placeholder="🔍 Search creators by name, handle, or niche (e.g., UI/UX, Tech, Vlogging)..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="ss-story-search-input"
            />
          </div>
        )}

        <div className="ss-stories-carousel-wrapper">
          {!isViewAllOpen && (
            <button className="ss-carousel-nav prev" onClick={() => handleScrollCarousel("left")}>‹</button>
          )}

          <div className={`ss-stories-grid ${isViewAllOpen ? "grid-expanded" : ""}`} ref={carouselRef}>
            {displayedStories.map((story, index) => (
              <div 
                key={story.id} 
                className="ss-story-card"
                style={{ animationDelay: `${index * 0.06}s` }}
              >
                <div className="ss-card-image-box" onClick={() => setSelectedVideoUrl(story.videoUrl)}>
                  <img src={story.image} alt={story.name} />
                  <span className="ss-platform-tag" style={{ backgroundColor: story.badgeColor }}>
                    {story.platform === "YouTube" && "▶ "}
                    {story.platform === "Instagram" && "📷 "}
                    {story.platform === "Freelancer" && "💼 "}
                    {story.platform === "Podcast" && "🎙️ "}
                    {story.platform}
                  </span>
                  <div className="ss-card-play-hover-overlay">
                    <span>▶ Watch Story</span>
                  </div>
                </div>

                <div className="ss-card-body">
                  <h3 className="ss-creator-name">{story.name}</h3>
                  <span className="ss-creator-handle">{story.handle}</span>
                  <p className="ss-creator-desc">{story.description}</p>

                  <div className="ss-card-footer-metrics">
                    <span>👤 <strong>{story.metric1}</strong></span>
                    <span>💸 <strong className="ss-text-green">{story.metric2}</strong></span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {!isViewAllOpen && (
            <button className="ss-carousel-nav next" onClick={() => handleScrollCarousel("right")}>›</button>
          )}
        </div>

        {/* LOAD MORE BUTTON WHEN EXPANDED */}
        {isViewAllOpen && visibleCount < filteredStories.length && (
          <div className="ss-load-more-wrapper">
            <button 
              className="ss-btn-load-more"
              onClick={() => setVisibleCount((prev) => prev + 3)}
            >
              Load More Stories ▾
            </button>
          </div>
        )}
      </section>

      {/*TESTIMONIALS */}
      <section className="ss-max-width ss-testimonials-section">
        <div className="ss-testimonials-banner">
          <div className="ss-testimonials-left">
            <h2>What Creators Say About Us</h2>
            <p>Hear from our community about how Creators Dost made a real difference in their journey.</p>
            <span className="ss-view-all-blue-link" onClick={() => setActiveFilter("all")}>View All Testimonials ➔</span>
          </div>

          <div className="ss-testimonials-right-cards">
            <div className="ss-testimonial-card">
              <span className="ss-quote-icon">“</span>
              <p>Creators Dost gave me the direction I was missing. The courses, mentors and community pushed me to become a full-time creator.</p>
              <div className="ss-author-row">
                <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=100&q=80" alt="Rohit Sharma" />
                <div>
                  <h5>Rohit Sharma</h5>
                  <span>YouTuber</span>
                </div>
              </div>
            </div>

            <div className="ss-testimonial-card">
              <span className="ss-quote-icon">“</span>
              <p>I learned practical strategies that actually worked. My income grew 5x in just 6 months!</p>
              <div className="ss-author-row">
                <img src="https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format&fit=crop&w=100&q=80" alt="Priya Verma" />
                <div>
                  <h5>Priya Verma</h5>
                  <span>Instagram Creator</span>
                </div>
              </div>
            </div>

            <div className="ss-testimonial-card">
              <span className="ss-quote-icon">“</span>
              <p>The mentorship and real-world projects helped me land high paying clients consistently.</p>
              <div className="ss-author-row">
                <img src="https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?auto=format&fit=crop&w=100&q=80" alt="Arjun Mehta" />
                <div>
                  <h5>Arjun Mehta</h5>
                  <span>Freelance Designer</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      
      <section className="ss-max-width ss-bottom-cta-section">
        <div className="ss-cta-blue-card">
          <div className="ss-cta-left-graphic">
            <span className="ss-trophy-emoji">🏆</span>
          </div>

          <div className="ss-cta-middle-text">
            <h2>Your Success Story <br /><span className="ss-text-yellow">Could Be Next!</span></h2>
            <p>Join thousands of creators who turned their passion into a thriving career.</p>
          </div>

          <div className="ss-cta-right-buttons">
            <button className="ss-btn-yellow" onClick={() => setIsSubmitModalOpen(true)}>
              Share Your Story
            </button>
            <button className="ss-btn-white-outline" onClick={() => window.location.hash = '#courses'}>
              Explore Courses
            </button>
          </div>
        </div>
      </section>

      {/* MODAL 1: VIDEO PLAYER */}
      {selectedVideoUrl && (
        <div className="ss-modal-fixed-curtain">
          <div className="ss-modal-backdrop-trigger" onClick={() => setSelectedVideoUrl(null)} />
          <div className="ss-video-modal-body">
            <button className="ss-modal-close-btn" onClick={() => setSelectedVideoUrl(null)}>✕</button>
            <CustomYouTubePlayer
              videoUrl={selectedVideoUrl}
              title="Creator Success Story Video"
              autoplay
            />
          </div>
        </div>
      )}

      {/* MODAL 2: SHARE YOUR STORY FORM */}
      {isSubmitModalOpen && (
        <div className="ss-modal-fixed-curtain">
          <div className="ss-modal-backdrop-trigger" onClick={() => setIsSubmitModalOpen(false)} />
          <div className="ss-form-modal-body">
            <button className="ss-modal-close-btn" onClick={() => setIsSubmitModalOpen(false)}>✕</button>
            
            <h3>Share Your Success Story 🚀</h3>
            <p className="ss-form-modal-sub">Inspire thousands of upcoming creators across India!</p>

            <form onSubmit={handleFormSubmit} className="ss-modal-form-stack">
              <div className="ss-input-field">
                <label>Your Full Name</label>
                <input 
                  type="text" 
                  required 
                  placeholder="e.g. Rahul Kapoor"
                  value={submitForm.name}
                  onChange={(e) => setSubmitForm({ ...submitForm, name: e.target.value })}
                />
              </div>

              <div className="ss-input-field">
                <label>Social Handle / Channel Link</label>
                <input 
                  type="text" 
                  required 
                  placeholder="e.g. @rahulcreates or youtube.com/c/rahul"
                  value={submitForm.handle}
                  onChange={(e) => setSubmitForm({ ...submitForm, handle: e.target.value })}
                />
              </div>

              <div className="ss-input-field">
                <label>Main Platform</label>
                <select 
                  value={submitForm.platform} 
                  onChange={(e) => setSubmitForm({ ...submitForm, platform: e.target.value })}
                >
                  <option value="YouTube">YouTube</option>
                  <option value="Instagram">Instagram</option>
                  <option value="Freelancing">Freelancing</option>
                  <option value="Podcasts">Podcast</option>
                </select>
              </div>

              <div className="ss-input-field">
                <label>Monthly Earnings / Growth Milestone</label>
                <input 
                  type="text" 
                  required 
                  placeholder="e.g. ₹1.5L /month or 100K Subscribers"
                  value={submitForm.earnings}
                  onChange={(e) => setSubmitForm({ ...submitForm, earnings: e.target.value })}
                />
              </div>

              <div className="ss-input-field">
                <label>Your Journey Summary</label>
                <textarea 
                  rows="3" 
                  required 
                  placeholder="How did Creators Dost help you reach your goals?"
                  value={submitForm.story}
                  onChange={(e) => setSubmitForm({ ...submitForm, story: e.target.value })}
                />
              </div>

              <button type="submit" className="ss-btn-primary ss-modal-submit-btn">
                Submit Story ➔
              </button>
            </form>
          </div>
        </div>
      )}

    </div>
  );
}